import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataCreditsValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'boolean',
            empty: false,
            mandatory: false
        };
    }
}
